import { Dialog } from "@headlessui/react"
import { KTitleSpan, KSpan, KButton } from "kahuna-base-react-components"
import React, { useEffect, useState } from "react"
import { lang } from "../../../../../constants/languages"
import { releases } from "../../../../../apis"
import { Artist, Release } from "../../../../../types"
import { mapListToCamelCase } from "../../../../../utility"

const SpotifyArtistModal = ({
  spotifyArtistModalReleaseId,
  setSpotifyArtistModalReleaseId
}: {
  spotifyArtistModalReleaseId?: number
  setSpotifyArtistModalReleaseId: (spotifyArtistModalReleaseId?: number) => void
}) => {
  const [artistList, setArtistList] = useState<Artist[]>([])

  useEffect(() => {
    if (!spotifyArtistModalReleaseId) {
      return
    }

    releases(`/release/release_artist_spotify_list/?release_id=${spotifyArtistModalReleaseId}`, "get")
      .then((resp) => {
        setArtistList(mapListToCamelCase(resp.data.results))
      })
      .catch((err) => {
        console.log(err)
      })
  }, [spotifyArtistModalReleaseId])

  return (
    <Dialog open={spotifyArtistModalReleaseId !== undefined} onClose={() => setSpotifyArtistModalReleaseId(undefined)}>
      <div className="fixed w-screen h-screen top-0 left-0 z-250 flex items-center justify-center bg-[#0000004d] ">
        <div className="p-6 shadow-md rounded-[10px] bg-[#fff]">
          <div className="flex flex-col gap-6">
            <div className="flex flex-col gap-8 items-center justify-center">
              <KTitleSpan text={"Artist Spotify Links"} fontSize={24} lineHeight="32px" />
              <div className="flex flex-col gap-4" style={{ textAlign: "center" }}>
                {artistList.length === 0 && (
                  <KSpan text={"No artists with Spotify links found."} fontSize={14} lineHeight="20px" />
                )}
                {artistList.map((artist) => (
                  <div key={artist.id} className="flex items-center mx-2">
                    <KSpan text={artist.name} fontSize={14} lineHeight="20px" color="#111" />
                    <div className="ml-20 flex gap-8">
                      {artist.spotifyId.split(",").map((spId, index) => (
                        <a
                          key={`${artist.spotifyId}-${index}`}
                          href={`https://open.spotify.com/artist/${spId}`}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          <KSpan text={spId} color="#005991" />
                        </a>
                      ))}
                    </div>
                  </div>
                ))}
              </div>
            </div>
            <div className="flex gap-3 justify-center items-center">
              <KButton
                text={lang.common.close}
                onClick={() => setSpotifyArtistModalReleaseId(undefined)}
                background="#fff"
                shadowDisabled={true}
              />
            </div>
          </div>
        </div>
      </div>
    </Dialog>
  )
}

export default SpotifyArtistModal
